import {
	NON_WORKING_DAY_CREATE_EDIT,
	NON_WORKING_DAY_CREATE_EDIT_ERROR,
	NON_WORKING_DAY_CREATE_EDIT_SUCCESS,
	NON_WORKING_DAY_DETAILS,
	NON_WORKING_DAY_DETAILS_ERROR,
	NON_WORKING_DAY_DETAILS_SUCCESS,
	NON_WORKING_DAY_DELETE,
	NON_WORKING_DAY_DELETE_ERROR,
	NON_WORKING_DAY_DELETE_SUCCESS,
	NON_WORKING_DAYS_LIST,
	NON_WORKING_DAYS_LIST_SUCCESS,
	NON_WORKING_DAYS_LIST_ERROR
} from "../actions/nonWorkingDays";
import {
	MENU_ITEMS
} from "../actions/roles";
import Vue from "vue";
import NonWorkingDaysService from '@/services/nonWorkingDays';

const state = {
	status: '',
	nonWorkingDay: {},
	nonWorkingDays: []
};

const getters = {
	getNonWorkingDay: state => state.nonWorkingDay,
	isNonWorkingDayLoaded: state => !!state.nonWorkingDay.name,
	getNonWorkingDays: state => state.nonWorkingDays
};

const actions = {
	[NON_WORKING_DAY_CREATE_EDIT]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.modalNonWorkingDay.id,
			name: data.modalNonWorkingDay.name,
			date: data.modalNonWorkingDay.date
		}
		return new Promise((resolve, reject) => {
			commit(NON_WORKING_DAY_CREATE_EDIT);
			NonWorkingDaysService.createEdit(requestData).then(responseData => {
				commit(NON_WORKING_DAY_CREATE_EDIT_SUCCESS);
				dispatch(NON_WORKING_DAY_DETAILS, responseData.nonWorkingDay.id);
				resolve(responseData);
			})
			.catch(error => {
				commit(NON_WORKING_DAY_CREATE_EDIT_ERROR, error);
				reject(error);
			});
		});
	},
	[NON_WORKING_DAY_DETAILS]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(NON_WORKING_DAY_DETAILS);
			NonWorkingDaysService.details(requestData)
				.then(data => {
					commit(NON_WORKING_DAY_DETAILS_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(NON_WORKING_DAY_DETAILS_ERROR, error);
					reject(error);
				});
		});
	},
	[NON_WORKING_DAY_DELETE]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(NON_WORKING_DAY_DELETE);
			NonWorkingDaysService.delete(requestData)
				.then(data => {
					commit(NON_WORKING_DAY_DELETE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(NON_WORKING_DAY_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[NON_WORKING_DAYS_LIST]: ({ commit }, data) => {
		let requestData = {
			perPage: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.search !== null) {
			requestData.search = data.tableProps.inputFilter.search;
		}
		if (data.tableProps.inputFilter.year) {
			requestData.year = data.tableProps.inputFilter.year;
		}
		return new Promise((resolve, reject) => {
			commit(NON_WORKING_DAYS_LIST);
			NonWorkingDaysService.list(requestData).then(nonWorkingDays => {
				commit(NON_WORKING_DAYS_LIST_SUCCESS, nonWorkingDays);
				resolve(nonWorkingDays);
			})
			.catch(error => {
				commit(NON_WORKING_DAYS_LIST_ERROR, error);
				reject(error);
			});
		});
	}
};

const mutations = {
	[NON_WORKING_DAY_CREATE_EDIT]: state => {
		state.status = 'loading';
	},
	[NON_WORKING_DAY_CREATE_EDIT_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[NON_WORKING_DAY_CREATE_EDIT_ERROR]: state => {
		state.status = 'error';
	},
	[NON_WORKING_DAY_DETAILS]: state => {
		state.status = 'loading';
	},
	[NON_WORKING_DAY_DETAILS_SUCCESS]: (state, details) => {
		state.status = 'success';
		Vue.set(state, 'nonWorkingDay', details);
	},
	[NON_WORKING_DAY_DETAILS_ERROR]: state => {
		state.status = 'error';
	},
	[NON_WORKING_DAY_DELETE]: state => {
		state.status = 'loading';
	},
	[NON_WORKING_DAY_DELETE_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[NON_WORKING_DAY_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[NON_WORKING_DAYS_LIST]: state => {
		state.status = 'loading';
	},
	[NON_WORKING_DAYS_LIST_SUCCESS]: (state, nonWorkingDays) => {
		state.status = 'success';
		Vue.set(state, 'nonWorkingDays', nonWorkingDays);
	},
	[NON_WORKING_DAYS_LIST_ERROR]: state => {
		state.status = 'error';
		Vue.set(state, 'nonWorkingDays', null);
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};